// extracted by mini-css-extract-plugin
export var button = "_b1-7";
export var buttonRow = "_b1-6";
export var fadeIn = "_b1-1";
export var gradient = "_b1-0";
export var panel = "_b1-2";
export var panelIn = "_b1-3";
export var subtitle = "_b1-5";
export var title = "_b1-4";